import gazelleBlue from './blue/blue.module';
import gazelleAnalytics from './analytics/analytics.module';

import gazelleConfig from './core.config';
import gazelleRun from './core.run';
import trustImagesConfig from './trust-images.config';
import tooltipsConfig from './tooltips.config';

import './core.scss';

export default angular.module('gazelle.core', [
  gazelleBlue,
  gazelleAnalytics,
  'ngMaterial',
  'rhino.core',
])
  .config(tooltipsConfig)
  .config(trustImagesConfig)
  .config(gazelleConfig)
  .run(gazelleRun)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/core/core.module.js